'use strict';

const { h } = require('phy');

function getImageSource(data, size) {
  const media = data.find(
    ({ isMainImage, mediaType }) => isMainImage && mediaType === 'Logo'
  );

  if (!media) {
    return null;
  }

  return media.mediaUrl.replace('{{options}}', `${size[0]},`);
}

function MerchantLogoImage({
  className = '',
  alt,
  data = [],
  size = [],
  lazyload = true,
}) {
  const imageSource = getImageSource(data, size);
  const imageTags = lazyload
    ? {
        src:
          'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
        'data-src': imageSource,
        class: `lazy-load no-bg ${className}`,
      }
    : {
        src: imageSource,
        class: className,
      };

  return h('img', {
    ...imageTags,
    alt,
  });
}

module.exports = MerchantLogoImage;
